import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/purple-ventures/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/workspace/purple-ventures/src/components/ui/separator.tsx");
